/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

// Extra RU phrases for the DOM translator in language.tsx (exact, trimmed
// text-node matches) plus a few pattern rules for strings that embed numbers.

export const extraRuPhrases: Record<string, string> = {
  // Shell / chrome
  "Search…": "Поиск…",
  "Expand sidebar": "Развернуть меню",
  "Collapse sidebar": "Свернуть меню",
  Style: "Стиль",
  Logout: "Выйти",
  "Sign Out": "Выйти",
  "Sign out": "Выйти",
  Sections: "Разделы",
  "Open menu": "Открыть меню",
  "Time and weather": "Время и погода",
  Primary: "Основное",
  Close: "Закрыть",
  Previous: "Назад",
  Next: "Далее",
  Actions: "Действия",
  Apply: "Применить",
  Run: "Запустить",
  Server: "Сервер",
  "+ weather": "+ погода",
  "Notifications alt+T": "Уведомления alt+T",

  // Network map / incident history
  "Network map": "Карта сети",
  "Incident history": "История инцидентов",
  "Find a device…": "Найти устройство…",
  "Problems only": "Только проблемы",
  "Click a device to open it.": "Нажмите на устройство, чтобы открыть его.",
  "No devices match.": "Устройства не найдены.",
  "No problems — everything is healthy.": "Проблем нет — всё в порядке.",
  "Docker hosts": "Docker-хосты",
  Router: "Роутер",
  Service: "Сервис",
  "Open now": "Открыто сейчас",
  Resolved: "Решено",
  Open: "Открыто",
  "Avg resolve": "Среднее время решения",
  "mean time to resolve": "среднее время до решения",
  "Most frequent": "Чаще всего",
  "no repeat offenders": "повторов нет",
  "Last 14 days": "Последние 14 дней",
  "All types": "Все типы",
  All: "Все",
    Today: "Сегодня",
  Yesterday: "Вчера",
  "No incidents recorded.": "Инцидентов нет.",
  "Nothing matches this filter.": "По фильтру ничего не найдено.",

  // Network overview
  Overview: "Обзор",
  Download: "Загрузка",
  Upload: "Отдача",
  Ping: "Пинг",
  "Connection quality": "Качество связи",
  "no baseline yet": "нет базы для сравнения",
  "no tests yet": "тестов пока нет",
  "no monitors yet": "мониторов пока нет",
  "no packet loss": "потерь нет",
  "Speed history": "История скорости",
  "run a test to start the history": "запустите тест, чтобы начать историю",
  "Schedule & servers": "Расписание и серверы",
  "Run test now": "Запустить тест",
  "Testing…": "Идёт тест…",
  "Not enough data yet": "Пока мало данных",
  "Needs attention": "Требует внимания",
  "anomalies and monitors above their threshold": "аномалии и мониторы выше порога",
  "The connection looks healthy": "Соединение в порядке",
  "Quality monitors": "Мониторы качества",
  "hosts pinged on a schedule to catch packet loss and latency spikes": "хосты, которые пингуются по расписанию, чтобы ловить потери и скачки задержки",
  "Add / manage": "Добавить / управлять",
  "No monitors yet.": "Мониторов пока нет.",
  "Add a monitor": "Добавить монитор",
  "packet loss": "потери пакетов",
  "avg latency": "средняя задержка",

  // Widgets, details and chart captions (fragments: JSX splits these into text nodes)
  "Event log": "Журнал событий",
  "Service uptime": "Аптайм сервисов",
  "Disk health": "Состояние дисков",
  "Speed test": "Тест скорости",
  open: "открыто",
  resolved: "решено",
  "7-day": "за 7 дней",
  "↓ traffic · last": "↓ трафик · последние",
  "↑ traffic": "↑ трафик",
  "↓ download · last": "↓ загрузка · последние",
  "↑ upload": "↑ отдача",
  "upload · last": "отдача · последние",
  up: "аптайм",
  "CPU · last": "CPU · последние",
  min: "мин",
  tests: "тестов",
  "collecting…": "сбор данных…",
  memory: "память",
  goroutines: "горутин",
  heap: "heap",
  Mbps: "Мбит/с",
  "vs avg": "к среднему",
  "vs average": "к среднему",
  "no baseline": "нет базы",
  download: "загрузка",
  upload: "отдача",
  ping: "пинг",
  "· avg": "· среднее",
  "· max": "· макс",
  "% loss": "% потерь",
  "· every": "· каждые",
  healthy: "в норме",
  warning: "с предупреждением",
  devices: "устройств",
  incidents: "инцидентов",
  "Needs attention ·": "Требуют внимания ·",
  "→ now": "→ сейчас",
  Type: "Тип",
  "Convert results into a": "Превратите результат в",
  kernel: "ядро",
  user: "пользователь",
  "% · system": "% · система",
  out: "исх.",
  read: "чтение",
  write: "запись",
  running: "работает",
  passed: "пройден",
  gateway: "шлюз",
  internet: "интернет",

  // Dashboard v2
  "Busiest servers": "Самые загруженные серверы",
  Disk: "Диск",
  "no servers yet": "серверов пока нет",
  "waiting for data…": "ждём данные…",
  "Recent events": "Недавние события",
  "nothing resolved yet": "решённых событий пока нет",
  "✓ all up": "✓ всё работает",
  "✕ all down": "✕ всё не работает",
  "no devices": "нет устройств",
  critical: "критично",
  "This service": "Этот сервис",
  "usage unavailable": "данные недоступны",
  MEMORY: "ПАМЯТЬ",
  "All systems operational": "Все системы в норме",
  "Open problems": "Открытые проблемы",
  "Nothing needs your attention": "Ничего не требует внимания",
  Services: "Сервисы",
  "Packet loss": "Потери пакетов",
  anomaly: "аномалия",
  router: "роутер",
  agent: "агент",
  switch: "коммутатор",
  docker: "docker",
  service: "сервис",
  packetloss: "потери",
  "Edit layout": "Править макет",
  "Quick Access": "Быстрый доступ",
  Resources: "Ресурсы",
  RAM: "ОЗУ",
  "CPU · last hour": "CPU · за час",
  peak: "пик",
  "peak ↓": "пик ↓",
  "no history yet": "истории пока нет",
  "load avg": "нагрузка",
  "↓ DOWNLOAD": "↓ ПРИЁМ",
  "↑ UPLOAD": "↑ ОТДАЧА",
  live: "сейчас",
  Infrastructure: "Инфраструктура",
  problems: "проблем",
  "6 problems": "6 проблем",
  unreachable: "недоступен",
  "SSH unreachable": "SSH недоступен",
  down: "не работает",
  anomalies: "аномалии",
  loss: "потери",
  latency: "задержка",
  "Network map": "Карта сети",
  "Incident history": "История инцидентов",
  "Last speed test": "Последний тест скорости",
  "↓ Mbps": "↓ Мбит/с",
  "↑ Mbps": "↑ Мбит/с",
  "ms ping": "мс пинг",
  "Speed test source": "Источник теста скорости",
  Unreachable: "Недоступен",

  "Server is offline or the agent is unreachable": "Сервер выключен или агент недоступен",
  "(live stream still connected)": "(живой поток всё ещё подключён)",
  "Agent unreachable": "Агент недоступен",

  // Pages v2
  "Speed by server": "Скорость по серверам",
  "Test all servers": "Проверить все серверы",
  "Last test": "Последний замер",
  "Tests": "Замеров",
  "Not enough data from this server yet": "По этому серверу данных пока мало",
  "Server": "Сервер",
  "Ports total": "Всего портов",
  "Filter switches…": "Фильтр коммутаторов…",
  "The switch does not answer SNMP.": "Коммутатор не отвечает по SNMP.",
  "No ports match this filter.": "Под фильтр порты не подходят.",
  "No switches match.": "Ничего не найдено.",
  "Ports with errors": "Порты с ошибками",
  "Ports with errors or discards": "Порты с ошибками или потерями",
  "No errors or discards on any port.": "Ошибок и потерь нет ни на одном порту.",
  "Unreachable": "Недоступен",
  "Disabled": "Отключён",
  "checking": "проверяется",
  "online": "в сети",
  "Model": "Модель",
  "Up": "Работают",
  "Down": "Не работают",
  "Total in": "Всего принято",
  "Total out": "Всего отправлено",
  "In errors": "Ошибки на входе",
  "Out errors": "Ошибки на выходе",
  "In discards": "Потери на входе",
  "Out discards": "Потери на выходе",
  "no answer to SNMP": "нет ответа по SNMP",
  "errors": "ошибки",
  "Edit switch": "Изменить коммутатор",
  "Remove switch": "Удалить коммутатор",
  "Who owns this address": "Кому принадлежит этот адрес",
  "More details": "Подробнее",
  "No data about this address": "Нет данных об этом адресе",
  "Organisation": "Организация",
  "Country": "Страна",
  "Network": "Сеть",
  "Ban this address": "Забанить этот адрес",
  "Domain": "Домен",
  "Touch feedback": "Отклик на касание",
  "A short vibration when you tap a button or a tab on a touch screen.": "Короткая вибрация при нажатии кнопки или вкладки на сенсорном экране.",
  "disk": "диск",
  "Panel disk": "Диск панели",
  "certificate expired": "сертификат истёк",
  "Set up water level": "Настроить уровень воды",
  "Stop cleaning": "Остановить уборку",
  "Change photo": "Сменить фото",
  "Remove photo": "Убрать фото",
  "Home Assistant gives no water control for this vacuum. Pick the entity that sets it:": "Home Assistant не даёт управление водой для этого пылесоса. Выберите сущность, которая её задаёт:",
  "Choose entity…": "Выберите сущность…",
  "No suitable entities": "Подходящих сущностей нет",
  "Mop wetness": "Влажность швабры",
  "Cleaning": "Уборка",
  "Docked": "На базе",
  "Charging": "Заряжается",
  "Returning to base": "Возвращается на базу",
  "Idle": "Ожидает",
  "Suction power": "Мощность всасывания",
  "Water level": "Уровень воды",
  "Cleaning mode": "Режим уборки",
  "Quiet": "Тихий",
  "Standard": "Стандарт",
  "Medium": "Средний",
  "Strong": "Мощный",
  "Low": "Низкий",
  "High": "Высокий",
  "Max": "Максимум",
  "Sweeping": "Сухая",
  "Mopping": "Влажная",
  "Sweep and mop": "Сухая и влажная",
  "Sweeping and mopping": "Сухая и влажная",
  "Dock": "На базу",
  "Find": "Найти",
  "Back": "Назад",
  "Home Assistant gives no cleaning settings for this vacuum.": "Home Assistant не отдаёт настройки уборки для этого пылесоса.",
  "Water level is not exposed by this integration.": "Уровень воды эта интеграция не отдаёт.",
  "Brush": "Щётка",
  "Filter": "Фильтр",
  "Brush 2": "Щётка 2",
  "Add schedule": "Добавить расписание",
  "Interval": "Интервал",
  "Exact time": "Точное время",
  "Create schedule": "Создать расписание",
  "uses the nearest server automatically": "используется ближайший сервер автоматически",
  "Choose a specific server": "Выбрать конкретный сервер",
  "+ time": "+ время",
  "Every 5 minutes": "Каждые 5 минут",
  "Every 15 minutes": "Каждые 15 минут",
  "Every 30 minutes": "Каждые 30 минут",
  "Every hour": "Каждый час",
  "Every 6 hours": "Каждые 6 часов",
  "Every 12 hours": "Каждые 12 часов",
  "Every day": "Каждый день",
  "Every week": "Каждую неделю",
  "Schedule created": "Расписание создано",
  "Add monitor": "Добавить монитор",
  "Delete monitor?": "Удалить монитор?",
  "Monitor created": "Монитор создан",
  "Monitor updated": "Монитор обновлён",
  "Monitor deleted": "Монитор удалён",
  "Could not save the monitor": "Не удалось сохранить монитор",
  "Could not create the schedule": "Не удалось создать расписание",
  "DNS filtering": "DNS-фильтрация",
  "AdGuard · 24 h": "AdGuard · 24 ч",
  "QUERIES": "ЗАПРОСОВ",
  "BLOCKED": "ЗАБЛОКИРОВАНО",
  "Internet outages": "Сбои интернета",
  "last 7 days": "за 7 дней",
  "OUTAGES": "СБОЕВ",
  "DOWNTIME": "ПРОСТОЙ",
  "0 min": "0 мин",
  "No outages this week": "За неделю сбоев не было",
  "Cameras": "Камеры",
  "snapshot": "снимок",
  "home": "дома",
  "away": "не дома",
  "No picture": "Нет изображения",
  "is recreated with the same settings. It restarts briefly; if the new one fails to start, the old one is put back.": "будет пересоздан с теми же настройками. Он ненадолго перезапустится; если новый не запустится, вернётся старый.",
  "update": "обновление",
  "Update the image": "Обновить образ",
  "Update container?": "Обновить контейнер?",
  "Update": "Обновить",
  "Container updated": "Контейнер обновлён",
  "Update failed": "Не удалось обновить",
  "Proxmox": "Proxmox",
  "Reboot": "Перезагрузить",
  "Shut down": "Выключить",
  "Start": "Запустить",
  "Sure?": "Точно?",
  "Command sent": "Команда отправлена",
  "Proxmox is unreachable": "Proxmox недоступен",
  "Security · last 24 h": "Безопасность · за 24 часа",
  "Failed logins": "Неудачные входы",
  "Banned": "Забанено",
  "Firewall drops": "Блокировки файрвола",
  "Web probes": "Веб-сканирование",
  "No hostile traffic seen": "Подозрительного трафика нет",
  "Ban": "Забанить",
  "banned": "забанен",
  "Address banned": "Адрес забанен",
  "24 h ago": "24 ч назад",
  "no backups yet": "бэкапов пока нет",
  "For a day": "На сутки",
  "For a week": "На неделю",
  "Forever": "Навсегда",
  "Unmute": "Вернуть",
  "Mute": "Заглушить",
  "forever": "навсегда",
  "Mute sound at night": "Без звука ночью",
  "Vibration blocked": "Вибрация заблокирована",
  "The browser refused to vibrate": "Браузер отказался вибрировать",
  "Sent: tap, OK, warning, alert": "Отправлено: касание, ОК, предупреждение, авария",
  "Test vibration": "Проверить вибрацию",
  "Vibration test": "Проверка вибрации",
  "Tap · OK · Warning · Alert": "Касание · ОК · Предупреждение · Авария",
  "Vibration": "Вибрация",
  "Test notification": "Проверить уведомление",
  "this is only a test": "это только проверка",
  "Test": "Проверка",
  "Critical failure": "Авария",
  "Warning": "Предупреждение",
  "Recovered": "Восстановлено",
  "Cleaning finished": "Уборка завершена",
  "Vacuum error": "Ошибка пылесоса",
  "Sound": "Звук",
  "tap once": "коснитесь экрана",
  "Refresh page": "Обновить страницу",
  "Start cleaning": "Начать уборку",
  "Stop and go home": "Остановить и домой",
  "Choose devices": "Выбрать устройства",
  "Fullscreen": "Полный экран",
  "beep": "сигнал",
  "dock": "на базу",
  "stop": "стоп",
  "Vacuums": "Пылесосы",
  "Mainly clear": "Преимущественно ясно",
  "Partly cloudy": "Переменная облачность",
  "Overcast": "Пасмурно",
  "Cloudy": "Облачно",
  "Fog": "Туман",
  "Drizzle": "Морось",
  "Rain": "Дождь",
  "Snow": "Снег",
  "Thunderstorm": "Гроза",
  "Add devices": "Добавить устройства",
  "from Home Assistant": "из Home Assistant",
  "Display devices": "Устройства на экране",
  "On the display": "На экране",
  "Nothing yet — tick devices on the right.": "Пока пусто — отметьте устройства справа.",
  "Search Home Assistant…": "Поиск по Home Assistant…",
  "run": "запуск",
  "unavailable": "недоступно",
  "closed": "закрыто",
  "open": "открыто",
  "active": "активно",
  "clear": "свободно",
  "locked": "заперто",
  "unlocked": "открыто",
  "devices": "устройства",
  "Lights": "Свет",
  "Fans": "Вентиляторы",
  "Covers & blinds": "Шторы и жалюзи",
  "Scenes": "Сцены",
  "Scripts": "Скрипты",
  "Buttons": "Кнопки",
  "Toggles": "Переключатели",
  "Automations": "Автоматизации",
  "Climate": "Климат",
  "Sensors": "Датчики",
  "Binary sensors": "Бинарные датчики",
  "Locks (read-only)": "Замки (только просмотр)",
  "People": "Люди",
  "Weather": "Погода",
  "All good": "Всё хорошо",
  "No connection to the panel": "Нет связи с панелью",
  "Internet": "Интернет",
  "Close hub": "Закрыть",
  "Night mode": "Ночной режим",
  "auto": "авто",
  "on": "вкл",
  "off": "выкл",
  "all checks pass": "все проверки пройдены",
  "restarting": "перезапускается",
  "exited": "остановлен",
  "created": "создан",
  "paused": "на паузе",
  "dead": "сбой",
  "Need attention": "Требуют внимания",
  "failed checks": "есть сбои",
  "not responding": "не отвечают",
  "all reachable": "все доступны",
  "Median ping": "Медианный пинг",
  "to the internet": "до интернета",
  "Highest RAM use": "Макс. использование ОЗУ",
  "All": "Все",
  "Problems": "Проблемы",
  "Find a router…": "Найти роутер…",
  "No routers match.": "Нет подходящих роутеров.",
  "Ping": "Пинг",
  "Checks": "Проверки",
  "connected": "подключён",
  "unreachable": "недоступен",
  "all services running": "все службы работают",
  "a service is not running": "какая-то служба не запущена",
  "ad domains are blocked": "рекламные домены блокируются",
  "ad blocking is not working": "блокировка рекламы не работает",
  "resolves public names": "публичные имена разрешаются",
  "cannot resolve public names": "публичные имена не разрешаются",
  "reachable": "доступен",
  "not reachable": "недоступен",
  "Err / drop": "Ошибки / потери",
  "Channel": "Канал",
  "Band": "Диапазон",
  "Width": "Ширина",
  "TX power": "Мощность TX",
  "Signal": "Сигнал",
  "Environments": "Окружения",
  "Stacks": "Стеки",
  "Images": "Образы",
  "Volumes": "Тома",
  "Networks": "Сети",
  "Kill": "Убить",
  "Remove": "Удалить",
  "State": "Состояние",
  "Stack": "Стек",
  "Image": "Образ",
  "IP address": "IP-адрес",
  "Published ports": "Опубликованные порты",
  "Created": "Создан",
  "Search name, image, stack, IP…": "Поиск: имя, образ, стек, IP…",
  "Stopped": "Остановлены",
  "Paused": "На паузе",
  "Failing": "Сбои",
  "Details": "Детали",
  "Stats": "Статистика",
  "Container": "Контейнер",
  "Started": "Запущен",
  "Finished": "Завершён",
  "Restarts": "Перезапуски",
  "Restart policy": "Политика перезапуска",
  "Platform": "Платформа",
  "Working dir": "Рабочий каталог",
  "Command": "Команда",
  "Memory limit": "Лимит памяти",
  "Gateway": "Шлюз",
  "Ports": "Порты",
  "Volumes & mounts": "Тома и монтирования",
  "Type": "Тип",
  "Container path": "Путь в контейнере",
  "Mode": "Режим",
  "Environment": "Окружение",
  "Show values": "Показать значения",
  "Hide values": "Скрыть значения",
  "Labels": "Метки",
  "Filter lines…": "Фильтр строк…",
  "Auto-refresh": "Автообновление",
  "Wrap": "Перенос",
  "Download": "Скачать",
  "Engine": "Движок",
  "Storage driver": "Драйвер хранилища",
  "CPUs": "Процессоры",
  "Address": "Адрес",
  "All containers are running.": "Все контейнеры работают.",
  "Capacity": "Ёмкость",
  "No Compose stacks on this host.": "На этом хосте нет Compose-стеков.",
  "Tags": "Теги",
  "Size": "Размер",
  "Used by": "Используется",
  "unused": "не используется",
  "Mount point": "Точка монтирования",
  "Driver": "Драйвер",
  "Scope": "Область",
  "Subnet": "Подсеть",
  "Loading…": "Загрузка…",
  "No containers on this host.": "На этом хосте нет контейнеров.",
  "No containers match the filters.": "Под фильтры ничего не подходит.",
  "Kill containers?": "Убить контейнеры?",
  "Remove containers?": "Удалить контейнеры?",
  "Kill container?": "Убить контейнер?",
  "Remove container?": "Удалить контейнер?",
  "disabled": "отключён",
  "stopped": "остановлено",
  "failing": "сбои",
  "images": "образов",
  "partial": "частично",
  "up": "работает",
  "down": "не работает",
  "Not attached to a network.": "Не подключён к сети.",
  "No mounts.": "Нет монтирований.",
  "No environment variables.": "Нет переменных окружения.",
  "No labels.": "Нет меток.",
  "No ports.": "Нет портов.",
  "This container isn't in the monitored set yet; statistics appear after the next poll.": "Контейнера ещё нет в мониторинге; статистика появится после следующего опроса.",
  "Select all": "Выбрать все",
  "Lines": "Строки",
  "Filter lines": "Фильтр строк",
  "Containers: ": "Контейнеры: ",
  "The permission prompt was dismissed.": "Запрос разрешения закрыт.",
  "Press Enable again and choose Allow in the browser prompt.": "Нажмите «Включить» ещё раз и выберите «Разрешить» в окне браузера.",
  "Notifications are blocked for this site.": "Уведомления для этого сайта заблокированы.",
  "Click the lock icon next to the address, allow Notifications, then reload the page.": "Нажмите на замок слева от адреса, разрешите уведомления и перезагрузите страницу.",
  "Push needs a secure connection.": "Для push нужно защищённое соединение.",
  "Open the panel over HTTPS (or http://localhost); browsers refuse push on plain HTTP.": "Откройте панель по HTTPS (или http://localhost): по обычному HTTP браузеры push не разрешают.",
  "The service worker isn't running yet.": "Service worker ещё не запущен.",
  "Reload the page once (Ctrl+Shift+R) and try again; a service worker is needed for push.": "Перезагрузите страницу (Ctrl+Shift+R) и попробуйте снова: для push нужен service worker.",
  "The browser refused to subscribe.": "Браузер отказал в подписке.",
  "Allow Notifications for this site in the browser's site settings.": "Разрешите уведомления для этого сайта в настройках браузера.",
  "The browser couldn't reach its push service.": "Браузер не смог связаться со своим push-сервисом.",
  "Chrome and Edge need access to Google's push service (FCM); Brave: turn on “Use Google Services for Push Messaging” in brave://settings/privacy; Chromium builds without Google services, some VPNs/blockers and Yandex Browser can't do push at all. Firefox and Safari use their own services.": "Chrome и Edge используют push-сервис Google (FCM) и должны до него дотянуться. В Brave включите «Use Google Services for Push Messaging» в brave://settings/privacy. В сборках Chromium без сервисов Google, при некоторых VPN и блокировщиках, а также в Яндекс Браузере push не работает вовсе. Firefox и Safari используют собственные сервисы.",
  "The panel rejected the subscription.": "Панель отклонила подписку.",
  "This browser does not support push notifications.": "Этот браузер не поддерживает push-уведомления.",
  "Requests": "Запросы",
  "Last minute": "За минуту",
  "Errors": "Ошибки",
  "4xx / 5xx / failed": "4xx / 5xx / отказы",
  "Unique clients": "Уникальных клиентов",
  "Busiest client": "Самый активный клиент",
  "Busiest service": "Самый активный сервис",
  "All machines": "Все машины",
  "Resume": "Продолжить",
  "Clear": "Очистить",
  "Clear the list (new events keep arriving)": "Очистить список (новые события продолжат приходить)",
  "From": "Откуда",
  "Source": "Источник",
  "Local": "Локальные",
  "External": "Внешние",
  "Proxy": "Прокси",
  "Bans": "Баны",
  "Firewall": "Файрвол",
  "Connections": "Соединения",
  "Show health checks": "Показывать проверки",
  "Reset filters": "Сбросить фильтры",
  "Nothing matches these filters.": "Под фильтры ничего не подходит.",
  "Time": "Время",
  "Client": "Клиент",
  "User": "Пользователь",
  "Host": "Хост",
  "Service": "Сервис",
  "Router": "Роутер",
  "Upstream": "Бэкенд",
  "Request": "Запрос",
  "Duration": "Длительность",
  "Sent / received": "Отправлено / получено",
  "Protocol": "Протокол",
  "Entry point": "Точка входа",
  "Port": "Порт",
  "Detail": "Подробности",
  "User agent": "User agent",
  "Only this client": "Только этот клиент",
  "Only this service": "Только этот сервис",
  "Only this path": "Только этот путь",
  "Copy IP": "Копировать IP",
  "Filters & details": "Фильтры и детали",
  "Search IP, service, path, user, user agent…": "Поиск: IP, сервис, путь, пользователь, user agent…",
  "Machine": "Машина",
  "The request feed isn't configured.": "Лента запросов не настроена.",
  "in config to read Traefik, SSH, Proxmox and other logs.": "в конфиге, чтобы читать логи Traefik, SSH, Proxmox и другие.",
  "Health checks (HEAD) are hidden by default.": "Проверки доступности (HEAD) по умолчанию скрыты.",
  "Set": "Задайте",
  "events": "событий",
  "Pause": "Пауза",
  "Speed test schedule": "Расписание замеров скорости",
  "tests that run on their own": "тесты, которые запускаются сами",
  "No schedules yet.": "Расписаний пока нет.",
  "Couldn't load schedules.": "Не удалось загрузить расписания.",
  "Schedule a test every few hours to build the speed history without lifting a finger.": "Запускайте тест раз в несколько часов, и история скорости будет копиться сама.",
  "Automatic server": "Сервер выбирается автоматически",
  "Pause schedule": "Приостановить расписание",
  "Resume schedule": "Возобновить расписание",
  "Delete schedule": "Удалить расписание",
  "Schedule deleted": "Расписание удалено",
  "Could not update the schedule": "Не удалось обновить расписание",
  "Could not delete the schedule": "Не удалось удалить расписание",
  "traffic passing through the reverse proxy": "трафик, проходящий через обратный прокси",
  "paused": "приостановлено",
  "Status of your whole infrastructure": "Состояние всей инфраструктуры",
  "not configured — set": "не настроено — задайте",
  "in config": "в конфиге",
  "Live requests": "Живые запросы",
  "Filter containers or projects...": "Фильтр контейнеров или проектов...",
  "Add one for a host you care about (a DNS server, your provider's gateway) and it will show up here.": "Добавьте монитор для важного хоста (DNS-сервер, шлюз провайдера), и он появится здесь.",
  Table: "Таблица",
  Cards: "Карточки",
  Ports: "Порты",
  "Try again": "Повторить",
  "Something went wrong": "Что-то пошло не так",
  "No servers yet": "Серверов пока нет",
  "Install the agent on a machine, then add it here to see live CPU, memory, disks, network and health.": "Установите агент на машину и добавьте её здесь, чтобы видеть CPU, память, диски, сеть и состояние в реальном времени.",
  "Add server": "Добавить сервер",
  "✕ unreachable": "✕ недоступен",
  "checking…": "проверка…",
  "No switches configured": "Коммутаторы не настроены",
  "Routers are added in the router-bot section of the config.": "Роутеры добавляются в секции router-bot конфигурации.",
  offline: "не в сети",
  disabled: "отключён",

  // Servers / Docker / Switches / Network
  "Edit server": "Изменить сервер",
  "Remove server": "Удалить сервер",
  "Add Docker host": "Добавить Docker-хост",
  "Add switch": "Добавить коммутатор",
  "Add Switch": "Добавить коммутатор",
  "Switches / Routers": "Коммутаторы и роутеры",
  Switch: "Коммутатор",
  Host: "Хост",
  "Filter switches...": "Фильтр коммутаторов...",
  "SNMP-polled switches and routers • Click a switch to view ports": "Коммутаторы и роутеры по SNMP • Нажмите на коммутатор, чтобы увидеть порты",
  "Server Selection": "Выбор сервера",
  "Choose between speedtest.net, iperf3 or librespeed servers": "Выберите серверы speedtest.net, iperf3 или librespeed",
  "All Countries": "Все страны",
  "Schedule Manager": "Расписание",
  "Create and manage your schedules": "Создание и управление расписаниями",
  Interval: "Интервал",
  "Exact Time": "Точное время",
  "Every Hour": "Каждый час",
  "Next run:": "Следующий запуск:",
  "in 1 hour": "через 1 час",
  "Speedtest, traceroute и проверка маршрутов для твоей инфраструктуры": "Тест скорости, трассировка и проверка маршрутов для вашей инфраструктуры",

  // Settings: notifications
  "Configure notification channels and rules for system alerts": "Каналы и правила уведомлений о событиях системы",
  "Browser & PWA notifications": "Уведомления браузера и PWA",
  "Get a system push on this device for every alert — works with the app installed, even when it's closed.": "Системные пуш-уведомления на это устройство по каждому событию — работают и при закрытом приложении.",
  "Enable notifications": "Включить уведомления",
  "Not enabled on this device.": "На этом устройстве не включены.",
  Channels: "Каналы",
  "Add Channel": "Добавить канал",
  "No channels configured": "Каналы не настроены",
  "Add a channel to get started": "Добавьте канал, чтобы начать",
  "Welcome to Notification Settings": "Настройка уведомлений",
  "Set up notification channels to receive alerts about system events, speed tests, and monitoring updates. Nyrvex supports 15+ notification services through Shoutrrr.": "Настройте каналы, чтобы получать оповещения о событиях системы, тестах скорости и мониторинге. Nyrvex поддерживает более 15 сервисов через Shoutrrr.",
  Email: "Эл. почта",
  "And more...": "И другие...",
  "Create a Channel": "Создайте канал",
  'Click "Add Channel" in the sidebar to configure your first notification service. You\'ll need the service URL from your provider.': "Нажмите «Добавить канал» и настройте первый сервис уведомлений. Понадобится URL сервиса от вашего провайдера.",
  "Configure Rules": "Настройте правила",
  "Select which events trigger notifications and set thresholds for alerts like high CPU usage or failed speed tests.": "Выберите события для уведомлений и задайте пороги, например высокую загрузку CPU или неудачные тесты скорости.",
  "Stay Informed": "Будьте в курсе",
  "Receive real-time alerts about system performance, agent status, and network quality directly to your preferred platform.": "Получайте оповещения о производительности, статусе агентов и качестве сети в удобный мессенджер.",
  "Available Notifications": "Доступные уведомления",
  "Speed Test Events": "События тестов скорости",
  "Completed tests, failures, and performance thresholds": "Завершённые тесты, ошибки и пороги производительности",
  "Packet Loss Monitoring": "Мониторинг потерь пакетов",
  "Network quality degradation and recovery alerts": "Ухудшение и восстановление качества сети",
  "System Monitoring": "Мониторинг системы",
  "Agent status, CPU, memory, disk, bandwidth, and temperature alerts": "Статус агента, CPU, память, диск, трафик и температура",
  "Ready to get started? Create your first notification channel to begin receiving alerts.": "Готовы начать? Создайте первый канал, чтобы получать оповещения.",
  "Create Your First Channel": "Создать первый канал",

  // Settings: time / distance / dashboard / weather
  "Configure timezone and time format preferences for the application": "Часовой пояс и формат времени в приложении",
  Timezone: "Часовой пояс",
  "Select Timezone": "Выберите часовой пояс",
  "Current Timezone:": "Текущий часовой пояс:",
  "All dates and times will be displayed in this timezone.": "Все даты и время показываются в этом часовом поясе.",
  "Using browser detection. This will adapt automatically to your system timezone changes.": "Определяется браузером и автоматически следует за часовым поясом системы.",
  "Time Format": "Формат времени",
  "24-Hour Format": "24-часовой формат",
  "Use 24-hour clock instead of 12-hour with AM/PM": "24-часовой формат вместо 12-часового с AM/PM",
  Preview: "Предпросмотр",
  "Time:": "Время:",
  "Full:": "Полностью:",
  "Note:": "Примечание:",
  "These settings affect how times are displayed in:": "Эти настройки влияют на отображение времени в:",
  "Speed test history charts and tooltips": "Графиках и подсказках истории тестов скорости",
  "Schedule manager and next run times": "Расписании и времени следующего запуска",
  "Monitor bandwidth charts": "Графиках трафика мониторов",
  "Notification timestamps": "Времени уведомлений",
  "All other time displays throughout the application": "Всех остальных местах приложения",
  "Quick Actions": "Быстрые действия",
  "Reset settings or apply common configurations": "Сброс настроек или типовые конфигурации",
  "Reset to Defaults": "Сбросить по умолчанию",
  "Choose between metric and imperial units for distance display": "Метрические или имперские единицы расстояния",
  "Distance Unit": "Единица расстояния",
  Metric: "Метрические",
  "Kilometers (km)": "Километры (км)",
  Imperial: "Имперские",
  "Miles (mi)": "Мили (mi)",
  "Configure recent speedtest history display behavior": "Сколько последних тестов скорости показывать",
  "Recent Speedtests": "Последние тесты скорости",
  "Rows shown on dashboard": "Строк на обзоре",
  rows: "строк",
  "Controls how many recent speedtests are loaded and shown in Dashboard": "Сколько последних тестов скорости загружается и показывается на обзоре",
  "Recent Speedtests.": "Последние тесты скорости.",
  Weather: "Погода",
  "City for the weather shown at the top of every page. Forecast comes from Open-Meteo — no account or API key needed.": "Город для погоды вверху каждой страницы. Прогноз берётся из Open-Meteo — аккаунт и ключ API не нужны.",
  Location: "Местоположение",
  City: "Город",
  "Leave empty and save to hide the widget.": "Оставьте пустым и сохраните, чтобы скрыть виджет.",
  Units: "Единицы",
  Celsius: "Цельсий",
  Fahrenheit: "Фаренгейт",
  "e.g. Amsterdam": "например, Москва",

  // Settings: wallpaper / kiosk / security
  Wallpaper: "Обои",
  "Personalize the background -- pick a preset, paste an image URL, or upload your own. Saved only in this browser.": "Настройте фон: выберите пресет, вставьте ссылку на картинку или загрузите свою. Сохраняется только в этом браузере.",
  Presets: "Пресеты",
  None: "Нет",
  Aurora: "Аврора",
  Sunset: "Закат",
  Ocean: "Океан",
  Midnight: "Полночь",
  Forest: "Лес",
  Slate: "Сланец",
  Candy: "Конфета",
  Nebula: "Туманность",
  "Image URL": "Ссылка на изображение",
  "Upload Image": "Загрузить изображение",
  "Choose an image (max 3MB)": "Выберите изображение (до 3 МБ)",
  Kiosk: "Киоск",
  "Settings for Nyrvex running as a wall-mounted or dedicated display": "Настройки для Nyrvex на настенном или выделенном экране",
  "Lock Kiosk editing": "Заблокировать редактирование в киоске",
  "Hides the Edit and Add Widget controls in Kiosk mode, so an iPad or other display mounted where anyone can touch it can't have its widgets rearranged, resized, or removed by accident. This is stored on this browser only -- exit Kiosk mode and come back here to unlock it again.": "Скрывает кнопки редактирования и добавления виджетов в режиме киоска, чтобы на планшете или экране, до которого может дотронуться любой, виджеты не переставили и не удалили случайно. Хранится только в этом браузере — выйдите из режима киоска и вернитесь сюда, чтобы разблокировать.",
  "Two-factor authentication and login activity for this account": "Двухфакторная аутентификация и история входов этой учётной записи",
  "Require a code from an authenticator app (in addition to your password) to sign in. Recommended if this panel is reachable from the internet.": "Требовать код из приложения-аутентификатора (помимо пароля) при входе. Рекомендуется, если панель доступна из интернета.",
  "No login attempts recorded yet.": "Попыток входа пока нет.",
};

type Rule = [RegExp, (m: RegExpMatchArray) => string];

function plural(n: number, one: string, few: string, many: string) {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
}

export const ruPatterns: Rule[] = [
  [/^↓ (\d+) · ↑ (\d+) Mbps$/, (m) => `↓ ${m[1]} · ↑ ${m[2]} Мбит/с`],
  [/^(\d+) servers? · (\d+) tests from this panel's connection$/, (m) => `${m[1]} ${plural(+m[1], 'сервер', 'сервера', 'серверов')} · ${m[2]} ${plural(+m[2], 'замер', 'замера', 'замеров')} с канала панели`],
  [/^Measured (\d+) of (\d+) servers$/, (m) => `Измерено ${m[1]} из ${m[2]} серверов`],
  [/^avg (\d+) · best (\d+)$/, (m) => `ср. ${m[1]} · лучший ${m[2]}`],
  [/^polled every (\d+)s$/, (m) => `опрос каждые ${m[1]} с`],
  [/^(\d+) of (\d+) ports up$/, (m) => `${m[1]} из ${m[2]} портов работают`],
  [/^(\d+) ports$/, (m) => `${m[1]} портов`],
  [/^Admin (up|down|testing|unknown) · ifIndex (\d+)$/, (m) => `Админ: ${({up:'вкл',down:'выкл',testing:'тест',unknown:'?'} as Record<string,string>)[m[1]]} · ifIndex ${m[2]}`],
  [/^Ban (.+)\? It will be blocked on this server\.$/, (m) => `Забанить ${m[1]}? Он будет заблокирован на этом сервере.`],
  [/^(\d+)% full$/, (m) => `заполнено на ${m[1]}%`],
  [/^certificate expires in (-?\d+) days?$/, (m) => `сертификат истекает через ${m[1]} дн.`],
  [/^(.+) and its history will be removed\.$/, (m) => `${m[1]} и его история будут удалены.`],
  [/^avg answer (\d+) ms$/, (m) => `средний ответ ${m[1]} мс`],
  [/^(\d+) h (\d+) min$/, (m) => `${m[1]} ч ${m[2]} мин`],
  [/^(\d+) min$/, (m) => `${m[1]} мин`],
  [/^Power on (.+)$/, (m) => `Включить ${m[1]}`],
  [/^Waking (.+)…$/, (m) => `Включаю ${m[1]}…`],
  [/^The newest image of (.+) is pulled and$/, (m) => `Будет скачан новый образ ${m[1]}, и контейнер`],
  [/^(\d+)\/(\d+) running$/, (m) => `${m[1]} из ${m[2]} запущено`],
  [/^(\d+) suspicious events$/, (m) => `${m[1]} подозрительных событий`],
  [/^disk (\d+)% used · (.+) free$/, (m) => `диск занят на ${m[1]}% · свободно ${m[2]}`],
  [/^backups (\d+) · last (.+)$/, (m) => `бэкапов ${m[1]} · последний ${m[2]}`],
  [/^Muted \((\d+)\)$/, (m) => `Заглушено (${m[1]})`],
  [/^until (.+)$/, (m) => `до ${m[1]}`],
  [/^(docked|cleaning|returning|paused|idle|error) · (\d+)%$/, (m) => `${({ docked: "на базе", cleaning: "уборка", returning: "возвращается", paused: "пауза", idle: "ожидает", error: "ошибка" } as Record<string, string>)[m[1]]} · ${m[2]}%`],
  [/^(docked|cleaning|returning|idle|error)$/, (m) => ({ docked: "на базе", cleaning: "уборка", returning: "возвращается", idle: "ожидает", error: "ошибка" } as Record<string, string>)[m[1]]],
  [/^on · (\d+)%$/, (m) => `вкл · ${m[1]}%`],
  [/^(\d+) to check$/, (m) => `${m[1]} проверить`],
  [/^\+(\d+) more$/, (m) => `ещё ${m[1]}`],
  [/^(\d+) down$/, (m) => `${m[1]} не работает`],
  [/^(\d+) not responding$/, (m) => `${m[1]} не отвечает`],
  [/^(Up|Exited \((\d+)\)|Restarting \((\d+)\)|Created) ?(?:about |(\d+) )?(an? |)?(second|minute|hour|day|week|month|year)s?( ago)?( \(Paused\))?$/, (m) => {
      const unit = ({ second: "сек.", minute: "мин.", hour: "ч", day: "дн.", week: "нед.", month: "мес.", year: "г." } as Record<string, string>)[m[6]];
      const n = m[4] ?? "1";
      const head = m[1] === "Up" ? "Работает" : m[1].startsWith("Exited") ? `Остановлен (${m[2]})` : m[1].startsWith("Restarting") ? `Перезапуск (${m[3]})` : "Создан";
      return `${head} ${n} ${unit}${m[7] ? " назад" : ""}${m[8] ? " (пауза)" : ""}`;
    }],
  [/^(\d+) (running|stopped|paused|failing|unused)$/, (m) => `${m[1]} ${({ running: "работает", stopped: "остановлено", paused: "на паузе", failing: "сбоит", unused: "не используется" } as Record<string, string>)[m[2]]}`],
  [/^(\d+) containers?$/, (m) => `${m[1]} ${plural(+m[1], "контейнер", "контейнера", "контейнеров")}`],
  [/^(\d+) \/ (\d+) running$/, (m) => `${m[1]} из ${m[2]} работает`],
  [/^(\d+)\/(\d+) running$/, (m) => `${m[1]} из ${m[2]} работает`],
  [/^(\d+) of (\d+)( · (\d+) selected)?$/, (m) => `${m[1]} из ${m[2]}${m[4] ? ` · выбрано ${m[4]}` : ""}`],
  [/^(\d+) environments?( · pick one.*)?$/, (m) => `${m[1]} ${plural(+m[1], "окружение", "окружения", "окружений")}${m[2] ? " · выберите, чтобы управлять контейнерами, стеками, образами, томами и сетями" : ""}`],
  [/^(\d+) lines$/, (m) => `${m[1]} строк`],
  [/^(\d+) mounts?$/, (m) => `${m[1]} монтирований`],
  [/^Docker (.+)$/, (m) => `Docker ${m[1]}`],
  [/^Stack: (.+) ✕$/, (m) => `Стек: ${m[1]} ✕`],
  [/^(\d+) CPU · (.+) RAM$/, (m) => `${m[1]} ЦП · ${m[2]} ОЗУ`],
  [/^(\d+) events( shown)?$/, (m) => `${m[2] ? "показано " : ""}${m[1]} ${plural(+m[1], "событие", "события", "событий")}`],
  [/^Show more \((\d+) left\)$/, (m) => `Показать ещё (осталось ${m[1]})`],
  [/^(\d+) events$/, (m) => `${m[1]} ${plural(+m[1], "событие", "события", "событий")}`],
  [/^Every (\d+)([smhd])$/, (m) => `Каждые ${m[1]} ${{ s: "сек", m: "мин", h: "ч", d: "дн" }[m[2] as "s" | "m" | "h" | "d"]}`],
  [/^Daily at (.+)$/, (m) => `Ежедневно в ${m[1]}`],
  [/^(\d+) of (\d+) active$/, (m) => `${m[1]} из ${m[2]} активны`],
  [/^next (.+)$/, (m) => `след. ${m[1]}`],
  [/^(\d+) servers$/, (m) => `${m[1]} серверов`],
  [/^✓ (\d+) running$/, (m) => `✓ ${m[1]} работает`],
  [/^(\d+) stopped$/, (m) => `${m[1]} остановлено`],
  [/^! (\d+) failing$/, (m) => `! ${m[1]} сбоит`],
  [/^All (\d+) checks pass$/, (m) => `Все ${m[1]} проверок пройдены`],
  [/^(\d+) (Servers?|servers?)$/, (m) => `${m[1]} ${plural(+m[1], "сервер", "сервера", "серверов")}`],
  [/^(\d+) (Routers?|routers?)( · (\d+) [Oo]ffline)?$/, (m) => `${m[1]} ${plural(+m[1], "роутер", "роутера", "роутеров")}${m[4] ? ` · ${m[4]} не в сети` : ""}`],
  [/^(\d+) (Hosts?|hosts?) · (.+)$/, (m) => `${m[1]} ${plural(+m[1], "хост", "хоста", "хостов")} · контейнеры на отслеживаемых Docker-хостах`],
  [/^(\d+) (Devices?|devices?) · (.+)$/, (m) => `${m[1]} ${plural(+m[1], "устройство", "устройства", "устройств")} · коммутаторы и роутеры по SNMP, нажмите, чтобы увидеть порты`],
  [/^! (\d+) down$/, (m) => `! ${m[1]} не работает`],
  [/^(\d+)\/(\d+) servers reporting$/, (m) => `${m[1]}/${m[2]} серверов отвечает`],
  [/^(\d+) (others|services) at 100%$/, (m) => `${m[1]} ${m[2] === "others" ? "остальных" : "сервисов"} на 100%`],
  [/^(\d+) resolved$/, (m) => `${m[1]} решено`],
  [/^Open (.+)$/, (m) => `Открыть ${m[1]}`],
  [/^up (\d+d \d+h|\d+d|\d+h \d+m|\d+h|\d+m)(.*)$/, (m) => `аптайм ${m[1].replace(/d/g, "д").replace(/h/g, "ч").replace(/m/g, "м")}${m[2]}`],
  [/^([+-]?\d+)% vs avg$/, (m) => `${m[1]}% к среднему`],
  [/^(\d+(?:\.\d+)?) (Mbps|Gbps)$/, (m) => `${m[1]} ${m[2] === "Gbps" ? "Гбит/с" : "Мбит/с"}`],
  [/^(Today|Yesterday|.+) — (\d+) incidents?$/, (m) => `${{ Today: "Сегодня", Yesterday: "Вчера" }[m[1] as "Today" | "Yesterday"] ?? m[1]} — ${m[2]} ${plural(+m[2], "инцидент", "инцидента", "инцидентов")}`],
  [/^· (\d+) threads$/, (m) => `· ${m[1]} потоков`],
  [/^· (\d+) files$/, (m) => `· ${m[1]} файлов`],
  [/^· (\d+)% wear$/, (m) => `· износ ${m[1]}%`],
  [/^(\d+) running$/, (m) => `${m[1]} запущено`],
  [/^(\d+)\/(\d+) running$/, (m) => `${m[1]}/${m[2]} работает`],
  [/^(\d+) failed$/, (m) => `${m[1]} сбой`],
  [/^(\d+) mounts?$/, (m) => `${m[1]} ${plural(+m[1], "раздел", "раздела", "разделов")}`],
  [/^(\d+) drives?$/, (m) => `${m[1]} ${plural(+m[1], "диск", "диска", "дисков")}`],
  [/^max (\d+) °C$/, (m) => `макс ${m[1]} °C`],
  [/^core (\d+): (\d+)%$/, (m) => `ядро ${m[1]}: ${m[2]}%`],
  [/^Service failed: (.+)$/, (m) => `Сбой сервиса: ${m[1]}`],
  [/^(.+) — (down|offline|unreachable)$/, (m) => `${m[1]} — ${{ down: "не работает", offline: "не в сети", unreachable: "недоступен" }[m[2] as "down" | "offline" | "unreachable"]}`],
  [/^(.+) · 24h ([\d.]+)% · 30d ([\d.]+)%$/, (m) => `${m[1]} · 24 ч ${m[2]}% · 30 д ${m[3]}%`],
  [/^24h ([\d.]+)% · 30d ([\d.]+)%$/, (m) => `24 ч ${m[1]}% · 30 д ${m[2]}%`],
  [/^worst: (.+) · ([\d.]+)% loss$/, (m) => `хуже всех: ${m[1]} · ${m[2]}% потерь`],
  [/^(\d+) min$/, (m) => `${m[1]} мин`],
  [/^(.+?)% vs average$/, (m) => `${m[1]}% к среднему`],
  [
    /^last (\d+) tests(?: · latest (just now|\d+[mhd] ago) via (.+))?$/,
    (m) => {
      const when = m[2] === "just now" ? "только что" : m[2] ? m[2].replace(/^(\d+)([mhd]) ago$/, (_, n, u) => `${n} ${{ m: "мин", h: "ч", d: "дн" }[u as "m" | "h" | "d"]} назад`) : "";
      return `${plural(+m[1], "последний", "последние", "последние")} ${m[1]} ${plural(+m[1], "тест", "теста", "тестов")}${when ? ` · последний ${when}, ${m[3]}` : ""}`;
    },
  ],
  [/^(\d+(?:\.\d+)?)% loss$/, (m) => `${m[1]}% потерь`],
  [/^(\d+) healthy$/, (m) => `${m[1]} в норме`],
  [/^(\d+) warnings?$/, (m) => `${m[1]} с предупреждением`],
  [/^(\d+) down$/, (m) => `${m[1]} не работает`],
  [/^(\d+) devices$/, (m) => `${m[1]} ${plural(+m[1], "устройство", "устройства", "устройств")}`],
  [/^(\d+) incidents?$/, (m) => `${m[1]} ${plural(+m[1], "инцидент", "инцидента", "инцидентов")}`],
  [/^Needs attention · (\d+)$/, (m) => `Требуют внимания · ${m[1]}`],
  [/^showing (\d+)$/, (m) => `показано ${m[1]}`],
  [/^(\d+) problems? needs? attention$/, (m) => `${m[1]} ${plural(+m[1], "проблема требует", "проблемы требуют", "проблем требуют")} внимания`],
  [/^(\d+)\/(\d+) checks healthy(.*)$/, (m) => `${m[1]}/${m[2]} проверок в норме${m[3].replace(" anomalies", " аномалий").replace(" anomaly", " аномалия")}`],
  [/^Run a speed test from (.+) now$/, (m) => `Запустить тест скорости с ${m[1]}`],
  [/^Auto \((.+)\)$/, (m) => `Авто (${m[1]})`],
  [/^(\d+) servers?$/, (m) => `${m[1]} ${plural(+m[1], "сервер", "сервера", "серверов")}`],
  [/^(\d+) problems?$/, (m) => `${m[1]} ${plural(+m[1], "проблема", "проблемы", "проблем")}`],
  [/^(\d+) rows?$/, (m) => `${m[1]} ${plural(+m[1], "строка", "строки", "строк")}`],
  [/^(\d+)([mhd]) ago(.*)$/, (m) => `${m[1]} ${{ m: "мин", h: "ч", d: "дн" }[m[2] as "m" | "h" | "d"]} назад${m[3]}`],
  [/^in (\d+) (minute|hour|day)s?$/, (m) => `через ${m[1]} ${{ minute: "мин", hour: "ч", day: "дн" }[m[2] as "minute" | "hour" | "day"]}`],
];
